import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const TrashcanIcon: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 32 32" {...props}>
    <path d="M21.8332 25.3333V12H11.1665V25.3333H21.8332ZM13.1665 4H19.8332L21.1665 5.33333H25.8332V8H7.1665V5.33333H11.8332L13.1665 4ZM8.49984 9.33333H24.4998V25.3333C24.4998 26.8 23.2998 28 21.8332 28H11.1665C9.69984 28 8.49984 26.8 8.49984 25.3333V9.33333ZM13.8332 14.6667H15.1665V22.6667H13.8332V14.6667ZM17.8332 14.6667H19.1665V22.6667H17.8332V14.6667Z" />
  </BlueprintIcon>
);